import { ExternalResourceType } from "@tsp-domains/external-resources/enums";
import { PropertyUuid } from "@tsp-domains/projects-portfolio/types";

import { SoulEntityContentType } from "../enums";
import {
  LoadSoulEntityInfoPayload,
  SoulEntityContentUnitRecord,
  SoulEntityContentUuid,
  SoulEntityInfoRecord,
  SoulEntityOrderRecord,
  SoulEntityOrderUuid,
} from "../types";

export type LoadSoulEntityInfoRequest = {
  contentUuid: SoulEntityContentUuid | null;
  contentType: SoulEntityContentType | null;
  orderUuid: SoulEntityOrderUuid | null;
};

export function transformLoadSoulEntityInfoPayloadToLoadSoulEntityInfoRequest(
  payload: LoadSoulEntityInfoPayload,
): LoadSoulEntityInfoRequest {
  return {
    contentUuid: payload.contentUuid,
    contentType: payload.contentType,
    orderUuid: payload.orderUuid,
  };
}

export type LoadSoulEntityInfoResponse = {
  customTaskData: {
    content: {
      uuid: SoulEntityContentUuid;
      type: SoulEntityContentType;
      title: string;
      url: string;
      propertyUuid: PropertyUuid | null;
    };
    order: {
      uuid: SoulEntityOrderUuid;
      title: string;
      url: string;
      propertyUuid: PropertyUuid | null;
      contentItems?: Array<{
        uuid: SoulEntityContentUuid;
        type: SoulEntityContentType;
        title: string;
        url: string;
        propertyUuid: PropertyUuid | null;
        duration: number;
        isDeleted: boolean;
      }>;
    };
  };
};

export function transformLoadSoulEntityInfoResponseToSoulEntityInfoRecord(
  response: LoadSoulEntityInfoResponse,
  _: unknown,
  payload: LoadSoulEntityInfoPayload,
): SoulEntityInfoRecord {
  let content: SoulEntityContentUnitRecord | null = null;
  if (response.customTaskData.content) {
    content = {
      uuid: response.customTaskData.content.uuid,
      type: response.customTaskData.content.type,
      link: {
        type: ExternalResourceType.LINK,
        title: response.customTaskData.content.title,
        href: response.customTaskData.content.url,
      },
      duration: null,
      propertyUuid: response.customTaskData.content.propertyUuid,
      isDeleted: false,
    };
  }

  let order: SoulEntityOrderRecord | null = null;
  if (response.customTaskData.order) {
    order = {
      uuid: response.customTaskData.order.uuid,
      link: {
        type: ExternalResourceType.LINK,
        title: response.customTaskData.order.title,
        href: response.customTaskData.order.url,
      },
      propertyUuid: response.customTaskData.order.propertyUuid,
      contents: response.customTaskData.order.contentItems
        ? response.customTaskData.order.contentItems.map((contentItem): SoulEntityContentUnitRecord => {
            return {
              type: contentItem.type,
              uuid: contentItem.uuid,
              link: {
                type: ExternalResourceType.LINK,
                title: contentItem.title,
                href: contentItem.url,
              },
              propertyUuid: contentItem.propertyUuid,
              duration: contentItem.duration,
              isDeleted: contentItem.isDeleted,
            };
          })
        : [],
    };
  }

  return {
    type: payload.type,
    content,
    order,
  } as SoulEntityInfoRecord;
}
